// extracted by mini-css-extract-plugin
module.exports = {"author":"author-module--author--3nLc4"};